import React, { useEffect, useState } from "react";
import { Tab, Nav } from 'react-bootstrap';
import secureStorage from '../../../config/encrypt';
import { useSearchParams,Link } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux'
import { toast } from "react-toastify";
import FullPageLoader from '@src/common/FullPageLoader';
import InsuranceListTable from '@src/pages/insurance/list/InsuranceListTable';
import InsuranceListTopFilter from '@src/pages/insurance/list/InsuranceListTopFilter';
import {getInsuranceList, leadListFilters,raisedSoa,downloadAllPolicies, getInsuranceListID, getDashboardListingID} from '@src/store/slices/insurance';
import {STATUS_TYPE,LEAD_LIST_FILTER, STATUS_CODES, COUNTRY_CODE, STATUS_TYPE_ID} from '@src/config/constant';
import * as HELPER from "@src/config/helper";
import RaisedSoaConfirmPopup from './RaisedSoaConfirmPopup';
import InsuranceListTableID from '@src/pages/insurance/list/InsuranceListTableID';
import PaymentInfoID from './PaymentInfoID';
import PaymentDetailModal from '../../payment/PaymentDetailModal'
import CommonModel from "@pages/commission/commonModel";
import CommonGrossModel from "@pages/CommonGrossModel";
import ProfitChangeModal from "@pages/ProfitChangeModal";
import { LEAD_STATUS } from "@src/config/id/constant";
import { useLanguage } from "@src/context/LanguageContext";


function InsuranceList() {
    const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    // const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const insuranceState = useSelector((state: any) => state.insurance);
    const commonState = useSelector((state: any) => state.common);
    const [loading, setLoading] = useState<boolean>(false);
    const [insuranceList, setInsuranceList] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    const [activeTab, setActiveTab] = useState<any>('');
    const [showPendingAmountDiv, setShowPendingAmountDiv] = useState(false);
    const [isCreateAccess , setIsCreateAccess] = useState(false);
    const [showRaisedSoaConfirmPopup, setShowRaisedSoaConfirmPopup] = useState(false);
    const [insuranceListCount , setInsuranceListCount] = useState(0);
    const [downloadingProcess, setDownloadingProcess] = useState(false);
    const [showPaymentInfoPopup, setShowPaymentInfoPopup] = useState(false);
    const [showbankModel, setShowbankModel] = useState(false);
    const [leadDetail, setLeadDetails] = useState();
    const [showPaymentDetailsPopup, setShowPaymentDetailsPopup] = useState(false);
    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [showAgentPointPopup, setShowAgentPointPopup] = useState(false);
    const [showApprovalPopup, setShowApprovalPopup] = useState(false);
    const [showPointsApprovalPopup, setShowPointsApprovalPopup] = useState(false);
    const [openMenuId, setOpenMenuId] = useState<number | null>(null);
     const [insuranceListData, setInsuranceListData] = useState<any>([]);

    // Temporary flag - will be removed later when screen is clear
    const [commonGrossPopup, setCommonGrossPopup] = useState(true);
    const [summaryPopup ,setSummaryPopup] = useState(false)
    const {translations} = useLanguage();

    let user_data = secureStorage.getItem("authAgentUserInfo");

    let searchKey: any = searchParams.get('searchKey');
    let status_type: any = searchParams.get('status_type');
    let datetype: any = searchParams.get('datetype');
    let from_date: any = searchParams.get('from_date');
    let to_date: any = searchParams.get('to_date');
    let soa_raised: any = searchParams.get('raised_soa');
    let current_nav: any = searchParams.get('current_nav');



     //  define defaultFilters HERE
    const status = LEAD_STATUS[status_type];
    
    const defaultFilters = isCountryId ? {"status_type":status_type,"page_number":1,"from_date":from_date,"to_date":to_date,...status,"user_id":user_data?.user_data?.user_id} : {page_number: 1,apptype: 4,lead_type: 6,status_type: "submitted",  datetype: "mtd",};
    const [selectedFilters, setSelectedFilters] = useState<any>(defaultFilters);
         
   



      useEffect(() => {
        // if (isCountryId && !insuranceState.dashboardCountID.bucket_data) {
        if (isCountryId ) {
            if(datetype){
                let fromDateRange = '';
                let toDateRange = '';
                if(datetype!=="cdr"){
                    let {from_date,to_date}:any= HELPER.dateReturn(datetype);
                    fromDateRange = from_date || '';
                    toDateRange = to_date || '';
                }else{
                    fromDateRange = from_date || '';
                    toDateRange = to_date || '';
                }
                let newObj = {
                    user_id: user_data.user_data.user_id,
                    pe_end_date: toDateRange,
                    ts_end_date: toDateRange,
                    pe_start_date: fromDateRange,
                    ts_start_date: fromDateRange
                };
                dispatch(getDashboardListingID(newObj))
            }
        }

  //  }, [isCountryId, insuranceState?.dashboardCountID])
    }, [isCountryId])
   

    useEffect(() => {
        let updatedSelctedFilters: any = {...selectedFilters};
        if (searchKey) {
            updatedSelctedFilters['searchKey'] = searchKey;
        }
        if(soa_raised){
            updatedSelctedFilters['raised_soa'] = +soa_raised;
        }
        if (status_type) {
            updatedSelctedFilters['status_type'] = status_type;
            setActiveTab(status_type);
        }
        if (datetype) {
            if(datetype!=="cdr"){
                let {from_date,to_date}:any= HELPER.dateReturn(datetype);
                if(from_date){
                    updatedSelctedFilters['from_date'] = from_date;
                }
                if(to_date){
                    updatedSelctedFilters['to_date'] = to_date;
                }
            }
            updatedSelctedFilters['datetype'] = datetype;
            if (from_date) {
                updatedSelctedFilters['from_date'] = from_date;
            }
            if (to_date) {
                updatedSelctedFilters['to_date'] = to_date;
            }

        }
       

        if (!searchKey && !datetype && !status_type) {

            let date_type:any = LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
            updatedSelctedFilters['datetype']=date_type;
            let {from_date,to_date}:any= HELPER.dateReturn(date_type);
            if(from_date){
                updatedSelctedFilters['from_date'] = from_date;
            }
            if(to_date){
                updatedSelctedFilters['to_date'] = to_date;
            }
            if(!updatedSelctedFilters?.['status_type']){
                updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
            }
        
        } else {
            if(!updatedSelctedFilters?.['status_type']){
                updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
            }
            setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
        }
        
        setActiveTab(updatedSelctedFilters['status_type']);
        //setShowPendingAmountDiv(pendingAmountDiv);
        if (!isCountryId) {
        getInsuranceListing(updatedSelctedFilters);
        }
        // eslint-disable-next-line
    }, [searchKey,datetype,status_type])

    useEffect(() => {
        if (Object.keys(insuranceState.insuranceListFilters).length) {
            setSelectedFilters({ ...insuranceState.insuranceListFilters });
        }
    }, [insuranceState]);

    //GET INSURANCE LIST API
    const getInsuranceListing = (params: any) => {
        setPaginationData({}); 
        let filters:any = {...params} 
        if(insuranceState.insuranceListFilters.datetype){
            filters.datetype = insuranceState.insuranceListFilters.datetype 
        }
        if(filters.from_date ==="" && insuranceState.insuranceListFilters.from_date){
            filters.from_date = insuranceState.insuranceListFilters.from_date
        }else{

        }
        if(filters.to_date ==="" && insuranceState.insuranceListFilters.to_date){
            filters.to_date = insuranceState.insuranceListFilters.to_date
        } 
        if(!params.shared_on_sort){
            filters.shared_on_sort = 'DESC'
        }
        dispatch(leadListFilters(filters));
        let modifiedFilters = { ...filters };
        if(!modifiedFilters?.searchKey) delete modifiedFilters["searchKey"];
        delete modifiedFilters["datetype"];

        // //  STATUS BASED FILTER FIX
       
        if (isCountryId) {
            if (current_nav === "potential_payment") {
                const potentialPayment = insuranceState?.dashboardCountID?.potential_payment;
                if (potentialPayment?.filter_params) {
                    // clean unwanted keys
                    delete modifiedFilters.status_id;
                    delete modifiedFilters.sub_status_id;
                    delete modifiedFilters.is_shared;
                    delete modifiedFilters.status_type;
                    modifiedFilters = {...modifiedFilters, user_id: user_data.user_data.user_id, searchKeyword: filters?.searchKey || "", page_number: filters?.page_number || 1,...potentialPayment.filter_params} 
                }
                // if (selectedBucket?.filter_params) {
                //     delete modifiedFilters.status_id;
                //     delete modifiedFilters.sub_status_id;
                //     delete modifiedFilters.is_shared;

                //     modifiedFilters = {...modifiedFilters, ...selectedBucket.filter_params,user_id: user_data.user_data.user_id };
                // }

            } else {
                const bucketData = insuranceState?.dashboardCountID?.bucket_data || [];
                const selectedBucket = bucketData.find(
                    (item: any) => item.type === modifiedFilters.status_type
                );

                if (selectedBucket?.filter_params) {
                    delete modifiedFilters.status_id;
                    delete modifiedFilters.sub_status_id;
                    delete modifiedFilters.is_shared;

                    modifiedFilters = {...modifiedFilters, ...selectedBucket.filter_params,user_id: user_data.user_data.user_id };
                }
            }

            // set Key for ID
            if (modifiedFilters?.searchKey) {
                modifiedFilters.searchKeyword = modifiedFilters.searchKey
                delete modifiedFilters.searchKey
                

            }
            if (current_nav !== "potential_payment") {
                if(params?.from_date){
                    modifiedFilters.from_date = params.from_date
                }
                 if(params?.to_date){
                    modifiedFilters.to_date = params.to_date
                }
            }
        }
        
        setLoading(true);
        if(!modifiedFilters?.page_number) modifiedFilters.page_number = 1
        dispatch(isCountryId ? getInsuranceListID(modifiedFilters) : getInsuranceList(modifiedFilters)).then((res: any) => {
           
            setLoading(false)
            if (res && res.status === STATUS_CODES['success']) {
                // For ID country, merge tab_data counts into paginationData so existing UI can use them directly
                if(isCountryId){
                    setPaginationData({
                    ...res.data.pagination, ...(isCountryId && res?.data?.tab_data
                        ? res.data.tab_data.reduce((acc: any, item: any) => {
                            acc[item.type] = item.value;
                            return acc;
                        }, {}) : {})
                });
                }else{
                    setPaginationData({ ...res.pagination})
                }
                setInsuranceList([])
                setInsuranceListCount(res.data.length);
                // set List for Country-ID
                if(isCountryId){
                    setInsuranceList([...res?.data?.leads])
                }
                else if(modifiedFilters?.status_type && (res?.pagination?.[modifiedFilters?.status_type])){
                    setInsuranceList([...res.data])
                }
                if(modifiedFilters && modifiedFilters.status_type==="pending_payment"){
                    if(!modifiedFilters?.raised_soa){
                        setShowPendingAmountDiv(true);
                    }else if(modifiedFilters?.raised_soa && modifiedFilters?.raised_soa===0){
                        setShowPendingAmountDiv(true);
                    }else{
                        setShowPendingAmountDiv(false);
                    }
                }else{
                    setShowPendingAmountDiv(false);
                }
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const activeTabHandler = (tab: any) => {
        let filters = {...selectedFilters, page_number: 1,status_type:tab};
        let datetype:any= ``;
        if(tab==="pending_payment"){
            datetype=LEAD_LIST_FILTER?.pendingPaymentFilters[0].value;
        }else{
            datetype=LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
        } 
        if (from_date && to_date) {
            filters = {...filters, datetype: datetype, from_date, to_date};
        } else {
            let {from_date,to_date}:any= HELPER.dateReturn(datetype);
            filters = {...filters, datetype:datetype,from_date,to_date}; 
        }
        setActiveTab(tab);
        getInsuranceListing(filters);
        setOpenMenuId(null);
    }

    const setSearchKeyword = (searchKey:any) => {
        let updatedSelctedFilters: any = {...selectedFilters};
        updatedSelctedFilters['searchKey'] = (searchKey)?searchKey:'';
        setSelectedFilters(updatedSelctedFilters);
    }

    const handleKeyDown = (event:any) => {
        if (event.key === "Enter") {
            getInsuranceListing(selectedFilters);
        }
    };

    const updateListFromChlid = (filterParams: any) => {
        getInsuranceListing(filterParams);
    }

    const updateUrl = (filterParams:any,filterKey: string) => {
        if(filterKey === 'resetAll'){
            if(searchParams.size){
                searchParams.delete('datetype');
                searchParams.delete('status_type');
                searchParams.delete('searchKey');
                searchParams.delete('from_date');
                searchParams.delete('to_date');
                searchParams.delete('raised_soa');
                delete selectedFilters['searchKey'];
                setSearchParams(searchParams);
            }else{
                getInsuranceListing(filterParams);
            }
            setSelectedFilters({...filterParams});
            
        }
    }

    useEffect(() => {
        const loggedInUser = secureStorage.getItem("authAgentUserInfo");
        if(loggedInUser.user_data.status === 1){
          setIsCreateAccess(true);
        }else{
          setIsCreateAccess(false);
        }
    }, []);

    // const addNewApp = () => {
    //     navigate('/create-insurance-policy?step=insurance_form');
    // }

    const is_raised_soa_confirm = () => {
        setShowRaisedSoaConfirmPopup(true);
    }

    const raised_soa = () => {
        setShowRaisedSoaConfirmPopup(false);
        let filters={...selectedFilters,raised_soa:0};
        delete filters["datetype"];
        delete filters["page_number"];

        setLoading(true);
        raisedSoa(filters).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_CODES['success']) {
                getInsuranceListing(selectedFilters);
               toast.success(res.message || res?.data?.message);
               getInsuranceListing(selectedFilters);
            }else{
                toast.error(res.message || res?.data?.message);
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const downloadAllPolicyZip = async (docParams: any) => {
        setDownloadingProcess(true);
        try {
            setDownloadingProcess(true);
            const response:any = await downloadAllPolicies(docParams);
            if (response?.data?.doc_arr?.length > 0) {
                await HELPER.downloadPolicy(response.data.doc_arr,'all_policies.zip','multiple');
            } else {
                toast.error("No File Found");
            }
        } catch (error) {
            toast.error("Failed to download policies.");
        }finally{
            setDownloadingProcess(false);
        }
    };


    useEffect(() => {
        if (isCountryId ) {
            let updatedSelctedFilters: any = {...selectedFilters};
            if (searchKey) {
                updatedSelctedFilters['searchKey'] = searchKey;
            }
            if(soa_raised){
                updatedSelctedFilters['raised_soa'] = +soa_raised;
            }
            if (status_type) {
                updatedSelctedFilters['status_type'] = status_type;
                setActiveTab(status_type);
            }
            if (datetype) {
                if(datetype!=="cdr"){
                    let {from_date,to_date}:any= HELPER.dateReturn(datetype);
                    if(from_date){
                        updatedSelctedFilters['from_date'] = from_date;
                    }
                    if(to_date){
                        updatedSelctedFilters['to_date'] = to_date;
                    }
                }
                updatedSelctedFilters['datetype'] = datetype;
                if (from_date) {
                    updatedSelctedFilters['from_date'] = from_date;
                }
                if (to_date) {
                    updatedSelctedFilters['to_date'] = to_date;
                }

            }
            if (!searchKey && !datetype && !status_type) {
                console.log("final");
                let date_type:any = LEAD_LIST_FILTER?.taskSummaryFilters[1].value;
                updatedSelctedFilters['datetype']=date_type;
                let {from_date,to_date}:any= HELPER.dateReturn(date_type);
                if(from_date){
                    updatedSelctedFilters['from_date'] = from_date;
                }
                if(to_date){
                    updatedSelctedFilters['to_date'] = to_date;
                }
                if(!updatedSelctedFilters?.['status_type']){
                    updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
                }
            
            } else {
                if(!updatedSelctedFilters?.['status_type']){
                    updatedSelctedFilters['status_type'] = STATUS_TYPE[0].value;
                }
                setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
            }
            
            setActiveTab(updatedSelctedFilters['status_type']);
            getInsuranceListing(updatedSelctedFilters);
        }
    }, []);

    const openModel = () => {
    setShowFilterPopup(true);
  };

  const handleFilterPopupClose = () => {
    setShowFilterPopup(false);

    // Temporary flag - will be removed later when screen is clear
    setCommonGrossPopup(false);
    setShowAgentPointPopup(false);
  };

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />

            {isCountryId &&
            <CommonModel
                show={showFilterPopup}
                handleClose={handleFilterPopupClose}
                filterType={"Filters"}
                showDateRange={true}
                buttonTitle={"Apply"}
                api={getInsuranceListing}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
            ></CommonModel>
            }

            <RaisedSoaConfirmPopup show={showRaisedSoaConfirmPopup} handleClose={() => {
                setShowRaisedSoaConfirmPopup(false)
            }} confirmNo={() => setShowRaisedSoaConfirmPopup(false)} confirmYes={raised_soa}></RaisedSoaConfirmPopup>
            <div className="container-fluid wap-bg-white">
                <div className="top-heading financer-lead-heding insurance-top-filer-heading d-flex">
                    {
                        isCountryId ?  <h1>  {(status_type ? translations?.COMMON_MSG?.APPLICATION :  translations?.COMMON_MSG?.PENDING_INS_APP)}</h1>: <h1> {translations?.COMMON_MSG?.INS_APP_LIST}</h1>
                    }            
                    {
                        isCountryId ?
                            <span>
                                <button className="btn-line btn-width-auto btn-bank-detail" onClick={()=>setShowbankModel(true)}>{translations?.TASK_SUMMARY?.OTO_BANK} </button>
                            </span>
                            : (isCreateAccess &&
                                <Link to='/create-insurance-policy'>

                                    <button className="btn-primary btn-width-auto" >
                                        <i className="ic-add"></i>{translations?.COMMON_MSG?.CREATE_LEAD}</button>

                                </Link>)

                    }
                </div>
                <div className="loan-filter-bg">
                    {!isCountryId &&
                    <div className="top-filter-bg insurance-filter-outer">
                        <InsuranceListTopFilter 
                            submitHandler={(filterParams: any) => { updateListFromChlid(filterParams); }}
                            updateUrl={(filterParams:any,filterKey:any)=>updateUrl(filterParams,filterKey)}
                            loader={(params: any) => setLoading(params)}
                            downloadPolicyZip={(docParams: any) => { downloadAllPolicyZip(docParams); }}
                            insuranceCount={insuranceListCount}
                            idDownloading = {downloadingProcess}
                        />
                    </div>
                    }
                    {
                        showPendingAmountDiv && 
                        <div className="top-filter-bg m-lg-t pending-amt-outer">
                            <div className="pending-amt-txt">
                                <div>
                                Pending Amount <span>{HELPER.addCurrencyFormatting(paginationData?.total_pending_amount) || 0}</span>
                                </div>

                                {
                                (paginationData && Object.keys(paginationData).length  && paginationData?.total_pending_amount>0) && <button className="btn-primary btn-width-auto m-lg-l" onClick={is_raised_soa_confirm}>Raised SOA</button>
                                
                                }
                            </div>
                            <div className="check-needs">
                                <i className="ic-info-icon1"></i>
                                Cheque needs to be paid - “OTO Insurance”
                            </div>
                        </div>
                    }
                    <div className=" insurnace-appliction-table-outer">
                    {
                        
                        activeTab && <Tab.Container id="left-tabs-example"  defaultActiveKey={activeTab}>
                                <Nav variant="pills" className={
                                    isCountryId
                                        ? (current_nav === "potential_payment" ? "flex-column nav nav-pills commission-filter" : "flex-column nav nav-pills nav nav-pills nav nav-pills tab-application-id")
                                        : "flex-column tab-line nav nav-pills nav nav-pills"
                                } onSelect={(k) => activeTabHandler(k)}>
                                {
                                    (current_nav !== "potential_payment") &&
                                    <div className="tab-list">
                                        {
                                            (isCountryId ? translations?.TASK_SUMMARY?.STATUS_TYPE_ID : STATUS_TYPE)?.map((data: any, key: number) =>
                                            <Nav.Item key={data.value}>
                                            <Nav.Link eventKey={data.value} >
                                            {data.label} 
                                            {isCountryId ?
                                            <span className="m-xs-l count-chip-bg">
                                            {(paginationData && paginationData[data.value]) || 0}
                                            </span>
                                            :
                                            <span className= "list-chips">
                                            {(paginationData && paginationData[data.value]) || 0}
                                            </span>
                                            }
                                            
                                            </Nav.Link>
                                            </Nav.Item>
                                            )
                                        }
                                    </div>
                                }

                                      
                                    {/* ID searching field */}
                                    {(isCountryId) ?
                                        (
                                            <div className="d-flex">
                                                <fieldset className="search-bx">
                                                    <div className="material" title={translations?.TASK_SUMMARY?.SEARCH_PLACEHOLDER}>
                                                        <input id="" type="text" placeholder={translations?.TASK_SUMMARY?.SEARCH_PLACEHOLDER}  name="RoleName" className="form-input lead_search_input" value={selectedFilters?.searchKey || ""} onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={handleKeyDown} />
                                                        <i className="ic-search"></i>
                                                    </div>
                                                </fieldset>
                                                <button type="button" className="btn-line btn-lg m-sm-l btn-filter" onClick={() => { openModel(); }}>          
                                                    {translations?.COMMON_MSG?.FILTER}
                                                    <i className="ic-filter m-sm-l"></i>
                                                    </button>
                                            </div>
                                        )
                                        :
                                        <>
                                            {/* PH searching fieldd */}
                                            <fieldset className="search-bx">
                                                <div className="material" title='Search By Insurance ID, Customer Name, Plate Number'>
                                                    <input id="" type="text" placeholder="Search By Insurance ID, Customer Name, Plate Number" name="RoleName" className="form-input lead_search_input" value={selectedFilters?.searchKey || ""} onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={handleKeyDown} />
                                                    <i className="ic-search"></i>
                                                </div>
                                            </fieldset>
                                        </>

                                    }

                                    
                            </Nav>


                            <Tab.Content>
                                    <Tab.Pane eventKey={activeTab}>
                                        {isCountryId ?
                                            <InsuranceListTableID
                                                insuranceList={insuranceList}
                                                paginationData={paginationData}
                                                getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} 
                                                current_nav = {current_nav}
                                                setShowPaymentInfoPopup = {setShowPaymentInfoPopup}
                                                setLeadDetails = {setLeadDetails}
                                                setShowPaymentDetailsPopup = {setShowPaymentDetailsPopup}
                                                setShowAgentPointPopup = {setShowAgentPointPopup}
                                                setLoading = {setLoading}
                                                activeTab ={activeTab}
                                                setShowPointsApprovalPopup= {setShowPointsApprovalPopup}
                                                setSummaryPopup = {setSummaryPopup}
                                                openMenuId = {openMenuId}
                                                setOpenMenuId = {setOpenMenuId}
                                                insuranceListData = {insuranceListData}
                                                setInsuranceListData = {setInsuranceListData}
                                                
                                                />

                                            :
                                            <InsuranceListTable
                                                insuranceList={insuranceList}
                                                paginationData={paginationData}
                                                getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} />
                                        }
                                    </Tab.Pane>
                                
                            </Tab.Content>
                        </Tab.Container>
                       
                    }
                     </div>              
                </div>
                {
                 isCountryId && showPaymentInfoPopup && <PaymentInfoID show = {showPaymentInfoPopup} handleClose={() => { setShowPaymentInfoPopup(false)}} leadDetail = {leadDetail}/>
                }
                {
                
                isCountryId && <CommonModel filterType="Bank Details" api={getInsuranceListing} show={showbankModel} handleClose={() => { setShowbankModel(false)}} />
            
                }
                {
                  isCountryId && showPaymentDetailsPopup && <PaymentDetailModal show={showPaymentDetailsPopup} handleClose={() => { setShowPaymentDetailsPopup(false) }} leadDetail={leadDetail} />
                }
                
                
                {/* Agent profit change screen */}
                {
                    isCountryId && showAgentPointPopup && (
                        <ProfitChangeModal
                            type="profit"
                            show={showAgentPointPopup}
                            handleClose={() => setShowAgentPointPopup(false)}
                            leadDetail = {leadDetail}
                            setLeadDetails= {setLeadDetails}
                            setShowAgentPointPopup = {setShowAgentPointPopup}
                            setShowApprovalPopup = {setShowApprovalPopup}
                            selectedFilters ={selectedFilters|| defaultFilters}
                            setInsuranceListData = {setInsuranceListData}
                            setLoading = {setLoading}

                        />
                    )
                }
                {/* Agent Cancel Request */}
                {
                    isCountryId && summaryPopup && (
                        <ProfitChangeModal
                            type="summary1"
                            show={summaryPopup}
                            handleClose={() => setSummaryPopup(false)}
                            leadDetail={leadDetail}
                            setLoading = {setLoading}
                            setInsuranceListData = {setInsuranceListData}

                        />
                    )}

                    {/*VP -SH approval screen */}
                {
                    isCountryId && showPointsApprovalPopup && (
                        <ProfitChangeModal
                            type="pointsApproval"
                            show={showPointsApprovalPopup}
                            handleClose={() => setShowPointsApprovalPopup(false)}
                            leadDetail = {leadDetail}
                            callFrom = "LeadList"
                            setLoading = {setLoading}
                            setInsuranceListData = {setInsuranceListData}
                        />
                    )}
                
            </div> 
        </React.Fragment>
    )
}

export default InsuranceList;